import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";


export default class Projects {
  constructor() {
    this.init();
  }

  init() {
    const sliderNodes = Array.from(document.querySelectorAll(".js-projects-slider"));
    if (!sliderNodes.length) return;

    sliderNodes.forEach((sliderEl) => {
      const root = sliderEl.closest(".projects__slider");
      if (!root) return;

      const nextEl = root.querySelector(".js-projects-next");
      const prevEl = root.querySelector(".js-projects-prev");
      const paginationEl = root.querySelector(".js-projects-pagination");
      const realSlidesCount = sliderEl.querySelectorAll(".swiper-wrapper > .swiper-slide").length;
      const shouldLoop = realSlidesCount > 3;
      const hasMultipleItems = realSlidesCount > 1;
      const autoplayConfig = shouldLoop
        ? {
            delay: 3200,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false;

      if (nextEl) nextEl.style.display = hasMultipleItems ? "" : "none";
      if (prevEl) prevEl.style.display = hasMultipleItems ? "" : "none";
      if (paginationEl) paginationEl.style.display = hasMultipleItems ? "" : "none";

      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      new Swiper(sliderEl, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 3,
        spaceBetween: 20,
        speed: 700,
        grabCursor: true,
        watchOverflow: true,
        loop: shouldLoop,
        rewind: !shouldLoop,
        autoplay: autoplayConfig,
        navigation: hasMultipleItems
          ? {
              nextEl,
              prevEl,
            }
          : false,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 14 },
          640: { slidesPerView: 2, spaceBetween: 16 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  }
}
